import { useState } from "react";
import css from "./index.module.css";
import { useLocation } from "react-router-dom";

import SEO from "@components/seo";
import MainContent from "@components/content";

import Tabs from "./menu";
import OrdersPage from "./pages/orders";
import Notifications from "./pages/notifications";
import Addresses from "./pages/addresses";
import About from "./pages/about";
import Settings from "./pages/settings";
import Organizations from "./pages/organizations";

export default function Account() {
  const location = useLocation();
  const [page, setPage] = useState((location.state as any)?.page || 0);

  return (
    <MainContent header="Аккаунт">
      <SEO
        title="Управление аккаунтом"
        description="Управление аккаунтом"
        ogUrl="https://рыбныимир.рф/"
      />

      <div className={css.account}>
        <Tabs active={page} setActive={setPage} />

        {page === 0 && (
          <OrdersPage />
        )}

        {page === 1 && (
          <Settings />
        )}

        {page === 2 && (
          <About />
        )}

        {(page === 3 || page === 4) && (
          <Addresses page={page} setPage={setPage} />
        )}

        {(page === 5 || page === 6) && (
          <Organizations page={page} setPage={setPage} />
        )}

        {page === 7 && (
          <Notifications />
        )}
      </div>
    </MainContent>
  );
}
